let storage_key = 'shopper_session_id';
let shopper_session_id = document.querySelector('[name=csrf-token]').getAttribute('content');
if (!window.swell.getCookie(storage_key)) {
    window.swell.setCookie(storage_key, shopper_session_id);
}